import styled from "styled-components";

import ButtonMenu from "@/components/atoms/Button/ButtonMenu/ButtonMenu";
import { breakpoints } from "@/styles/breakpoints";

export const StyledUnselectedBrokerImage = styled.img`
    max-width: 60px;
    max-height: 60px;
    margin-right: 16px;
`;

export const StyledBrokerButton = styled(ButtonMenu)`
    .broker-button-image {
        display: none;
        height: 48px;
        overflow: hidden;
        background: var(--color-white);
        border-radius: 0.5rem;
        padding: 2px;
        box-sizing: border-box;
        min-width: 48px;

        .broker-image {
            width: 100%;
            margin: auto;
            max-width: 70px;
        }

        @media ${breakpoints.xs} {
            display: flex;
            height: 36px;
            min-width: 36px;
        }
    }

    .broker-button-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: left;
        @media ${breakpoints.xs} {
            margin-left: 15px;
        }

        .broker-button-name {
            @media ${breakpoints.xs} {
                font-size: var(--size-12);
                line-height: 14px;
            }
            display: -webkit-box;
            align-items: center;
            width: 90%;
            overflow: hidden;
            font-size: var(--size-16);
            font-weight: var(--weight-600);
            line-height: 24px;
            color: var(--color-primary-fg);
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;
        }

        .dropdown-arrow {
            path {
                fill: var(--color-primary-fg);
            }
        }
    }
`;
